import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import WelcomePage from "./pages/WelcomePage";
import RegistrationPage from "./pages/NewUsersPage";
import ReturningUserPage from "./pages/ReturningUsersPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage.js";
import CreateCollectionPage from "./pages/CreateCollectionPage.js";
import EditCollectionPage from "./pages/EditCollectionPage.js";
import EditCollectionsSelectorPage from "./pages/EditCollectionsSelectorPage.js";
import ViewCollectionsSelectorPage from "./pages/ViewCollectionsSelectorPage.js";
import ViewCollectionPage from "./pages/ViewCollectionPage.js";
import PostSavePage from "./pages/PostSavePage.js";
import './styles/utilities.css';
import OverviewPage from "./pages/OverviewPage";
import CommunityPage from "./pages/CommunityPage";
import InspirePage from "./pages/InspirePage";
import ProfilePage from "./pages/ProfilePage";
import PublicProfilePage from "./pages/PublicProfilePage";
import PublicCollectionsPage from "./pages/PublicCollectionsPage";
import AutoLanding from "./utils/AutoLanding.js";
import useIOSFix from "./hooks/useIOSFix";
import DiscoverPage from "./pages/DiscoverPage";
import FinishSignupPage from "./pages/FinishSignupPage";
import NotificationsPage from "./pages/NotificationsPage";
import "./styles/Navigation.css";

const App = () => {
  useIOSFix();
  
  return (
    <Router>
      <Routes>
        {/* Welcome Page Route */}
        <Route path="/" element={<AutoLanding />} /> 
        <Route path="/welcome" element={<WelcomePage />} />
        {/* New Page Route */}
        <Route path="/new" element={<RegistrationPage />} />
        {/* Returning User Route */}
        <Route path="/returning" element={<ReturningUserPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/home-page" element={<HomePage />} />
        <Route path="/upload-collection" element={<CreateCollectionPage />} />
        <Route path="/post-save" element={<PostSavePage />} />
        <Route path="/edit-collection-selector" element={<EditCollectionsSelectorPage />} />
        <Route path="/view-collection-selector" element={<ViewCollectionsSelectorPage />} />
        <Route path="/edit-collection" element={<EditCollectionPage />} />
        <Route path="/view-collection" element={<ViewCollectionPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/inspiration" element={<InspirePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/u/:username" element={<PublicProfilePage />} />
        <Route
  path="/u/:username/collections"
  element={<PublicCollectionsPage />}
/>
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/finish-signup/:token" element={<FinishSignupPage />} />
        <Route path="/p/:slug" element={<ViewCollectionPage />} />
        <Route path="/k/:key" element={<ViewCollectionPage />} />
        <Route
    path="/notifications"
    element={<NotificationsPage />}
/>
      </Routes>
    </Router>
  );
};

export default App;
